/* Probably don't need this now that its in process.env but lets leave it since changing it may break things */
import React from 'react';

interface iResourceStrings {
    invoiceResearch: {
        toolTips;
    };
    carrierAdmin: {
        toolTips;
    };
    customerAdmin: {
        toolTips;
    };
    manageExceptions: {
        toolTips;
    };
    invoiceEntry: {
        toolTips;
    };
    invoiceMaintenance: {
        toolTips;
    };
    imageIndexing: {
        toolTips;
    };
    manageImages: {
        toolTips;
    };
    manageScans: {
        toolTips;
    };
    userRoles: {
        toolTips;
    };
    userAdmin: {
        toolTips;
    };
}

const ResourceStringContext = React.createContext({} as iResourceStrings);

const resourceStrings = {
    invoiceResearch: {
        toolTips: {
            billTo: '',
            carrier: 'See invoices from just a single carrier',
            mode: 'Narrow down the results by Transportation Mode, such as Less Than Loaded (LTL) or Truck Load (TL)',
            entryType: '',
            invoiceType: [
                'Which kinds of invoices to include in the search',
                'If no options are selected, Active and Customer Overfund invoices will be included',
            ],
            entered: 'The date Sunset entered an invoice into PayLOGIK',
            processed: 'The date Sunset processed an invoice for payment',
            checkDate:
                'The date Sunset sent the check to the carrier for an invoice',
            shipped: 'The date the carrier reports picking up the load',
            invoices: [
                '* = wildcard. Example: Use 1234* for invoice 12345 OR *2345 for 12345',
                'For multiple invoices use a comma. Example, 12345,12346,12347',
            ],
            airbillNum: [
                '* = wildcard. Example: Use 1234* for invoice 12345 OR *2345 for 12345',
                'For multiple invoices use a comma. Example, 12345,12346,12347',
            ],
            checks: '',
            status: '',
            shipper: 'Search based on the Shipper location or name',
            consignee: 'Search based on the Receiver location or name',
            referenceValue: '',
            referenceCodes: '',
            partyName:
                'Searches the Location name.  Use * for wildcard searches',
            partyAddress:
                'Searches the Street Address 1 field.  Use * for wildcard searches',
            partyCity: 'Use * for wildcard searches',
            partyState: '2 character State or Province code',
            partyPostal: 'US use Zip5, CN use 6 with no space',
            gridSelectAll: 'Select or deselect all currently visible rows',
        },
    },
    manageExceptions: {
        toolTips: {
            billTo: '',
            btnSelectAll: 'Select all loaded rows in the grid',
            btnClearSel: 'Clear all selections in the grid',
            btnEntered:
                'Accept the selected invoices with their entered values',
            btnAudited:
                'Accept the selected invoices with their audited values',
            btnAdjusted:
                'Accept the selected invoices with their adjusted values',
            btnRefuse: 'Refuse the selected invoices',
            btnDelete: 'Delete the selected invoices',
            btnSvcFailAppr:
                'Approve the selected service-fail invoices, removing any fuel and freight charges',
            btnSvcFailDecl:
                'Decline the selected service-fail invoices, accepting all charges as-is',
            btnExportCsv:
                'Export all invoices to a CSV file for use in Excel or other programs',
        },
    },
    invoiceEntry: {
        toolTips: {
            btnAddAirbill: 'Add another Air-Bill to this shipment',
            btnDelAirbill: 'Delete this Air-Bill from this invoice',
            btnAbBundleDetails: 'View details on this shipment bundle',
            btnAbList: 'View a list of all Air-Bills on this shipment',
            btnAbFirst: 'View the first Air-Bill on this shipment',
            btnAbPrev: 'View the previous Air-Bill on this shipment',
            btnAbNext: 'View the next Air-Bill on this shipment',
            btnAbLast: 'View the last Air-Bill on this shipment',
            btnRevList: 'View a list of all revisions on this invoice',
            btnRevFirst: 'View the first revision on this invoice',
            btnRevPrev: 'View the previous revision on this invoice',
            btnRevNext: 'View the next revision on this invoice',
            btnRevLast: 'View the last revision on this invoice',
            btnCarrierWeb: "Visit the carrier's website",
            btnEdiView: 'View EDI info for this invoice',
            saveButton: 'Save this invoice information',
            clearButton: 'Clear data and start a new invoice',
            btnPostalSearch: 'Look up location information',
            deleteButton: 'Delete this invoice',
            memoButton: 'Place this invoice into MEMO status',
            realButton: 'Restore this invoice to an active state',
        },
    },
    invoiceMaintenance: {
        toolTips: {
            purgeRecType: 'Select the type of invoice record to purge',
            purgeCarrier:
                'Select the carrier whose invoice record will be purged',
            purgeInvNum: 'Enter the invoice # of the invoice record to purge',
            purgeInvRev: [
                'Enter the invoice revision number of the invoice record to purge',
                'Note that revision numbers begin at 0 for the first revision',
            ],
        },
    },
    imageIndexing: {
        toolTips: {
            btnList: 'See a list of images needing indexing',
            btnDownload: 'Download the image for improved viewing',
            btnFirst: 'Jump to the first image needing indexing',
            btnPrev: 'Jump to the previous image needing indexing',
            btnNext: 'Jump to the next image needing indexing',
            btnLast: 'Jump to the last image needing indexing',
            btnIndex: 'Index this image with the associated info',
            btnDelete: 'Delete this image without indexing it',
            btnCopyInvNum:
                'Link this image to the same invoice number as the previously-indexed one',
            btnCopyShipNum:
                'Link this image to the same shipment number as the previously-indexed one',
        },
    },
    carrierAdmin: {
        toolTips: {
            fieldName: '',
            allowDupeAb: '',
            fieldAddr1: '',
            fieldAddr2: '',
            fieldAddr3: '',
            fieldCity: '',
            fieldState: '',
            fieldPostal: '',
            fieldCountry: '',
            fieldPhone: '',
            fieldEmail: '',
            fieldFax: '',
            fieldScac: '',
            fieldImgId: '',
            fieldInvType: '',
            fieldMode: '',
            fieldFamily: '',
        },
    },
    customerAdmin: {
        toolTips: {
            fieldName: '',
            isParent: '',
            fieldParent: '',
            fieldAddr1: '',
            fieldAddr2: '',
            fieldCity: '',
            fieldState: '',
            fieldPostal: '',
            fieldCountry: '',
            fieldPrimaryContact: '',
            fieldPrimaryPhone: '',
            fieldPrimaryEmail: '',
            fieldGlFunction: '',
            enableImportReview: '',
            enableMatchPayLiability: '',
            enableMatchPayAccessorial: '',
            enableMatchPayWeight: '',
            fieldFreightVariance: '',
            fieldTotalWeightVariance: '',
            comments: '',
            fieldSfrEmail: '',
            fieldFboGlAcct: '',
            fieldPayToTerms: '',
            fieldPayStart: '',
            fieldPayDays: '',
            fieldFundOffsetDays: '',
            fieldAutobill: '',
            fieldComdataId: '',
            fieldAudit: '',
            fieldCmCustId: '',
            enableBenchmarking: '',
            fieldAllowedVariance: '',
            fieldVarianceException: '',
            fieldMaxClass: '',
            fieldClassException: '',
            fieldMaxCharge: '',
            fieldChargeException: '',
            chkImportFees: 'Allows importing created invoices into PayLOGIK',
            chkPrintFees: '',
            chkEmailFees: '',
            chkCombineChildren: '',
            chkUseParentRules: '',
            fieldChildReport: '',
            fieldStopDate: '',
        },
    },
    manageImages: {
        toolTips: {
            btnDisconnect:
                'Fully disconnect selected image so it can be linked to another invoice',
            btnDelete:
                'Delete selected image, removing it from invoices entirely',
        },
    },
    manageScans: {
        toolTips: {
            btnUpdate: 'Assign selected images to yourself',
        },
    },
    userRoles: {
        toolTips: {
            btnAdd: 'Create a new user role',
            btnCopy: 'Copy an existing user role to a new one',
            btnNoAccess: 'Remove all access for selected rows',
            btnViewOnly: 'Set view-only access for selected rows',
            btnFullAccess: 'Set full access for selected rows',
        },
    },
    userAdmin: {
        toolTips: {
            btnAdd: 'Add a new user to the system',
            btnSave: "Save changes to this user's profile",
            btnSuspend: "Suspend this user's access to the system",
            btnUnsuspend: "Restore this user's access to the system",
            btnPassword: 'Assign a new password to this user',
            defaultMaxRec:
                'The default maximum records returned in reports. Cannot exceed absolute maximum records.',
            maxMaxRec:
                'The absolute maximum number of records returned in reports. Cannot exceed 10,000.',
        },
    },
} as iResourceStrings;

export const ResourceStringProvider = ({children}) => (
    <ResourceStringContext.Provider value={resourceStrings}>
        {children}
    </ResourceStringContext.Provider>
);

export const useResourceStrings = () => {
    const context = React.useContext(ResourceStringContext);
    if (context === undefined) {
        throw new Error(
            'ResourceStringContext must be used within a ResourceStringProvider'
        );
    }
    return context;
};
